import { render, staticRenderFns } from "./parent-fee-sheet-row-details.vue?vue&type=template&id=66820884&scoped=true&"
import script from "./parent-fee-sheet-row-details.vue?vue&type=script&lang=ts&"
export * from "./parent-fee-sheet-row-details.vue?vue&type=script&lang=ts&"
import style0 from "./parent-fee-sheet-row-details.vue?vue&type=style&index=0&id=66820884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66820884",
  null
  
)

export default component.exports